import { render, staticRenderFns } from "./errorsDetails.vue?vue&type=template&id=6b3ce80d&lang=pug"
import script from "./errorsDetails.vue?vue&type=script&lang=js"
export * from "./errorsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports